import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 4.5L4.40653 14.6294C4.47473 15.6815 5.348 16.5 6.40234 16.5H11.5977C12.652 16.5 13.5253 15.6815 13.5935 14.6294L14.25 4.5",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 4.5H15.75",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 4.5V3.5C6 2.39543 6.89543 1.5 8 1.5H10C11.1046 1.5 12 2.39543 12 3.5V4.5",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 6.75V14.25",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 6.75V14.25",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 6.75V14.25",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgActivityDelete;
